export const secondQuotaTime = 30;
export const casheaQuotaTime = 14;
